import type Enums from '../Enums';

export type FixedPricingByCompanyProduct = {
  amount: string;
  fixedPricingId: string;
  fixedPricingName: string;
};

export type ImportedPricingByCompanyProduct = {
  amount: string;
  importedPricingId: string;
  importedPricingName: string;
};

export type FixedPricingAdjustment = {
  id: string;
  name: string;
  value: string;
  type: Enums.MarginConfiguration;
};

export type FixedPricingByCompanyLocation = {
  products: Record<string, FixedPricingByCompanyProduct>;
  importedProducts: Record<string, ImportedPricingByCompanyProduct>;
  adjustment?: FixedPricingAdjustment;
};

export type FixedPricingByCompany = Record<string, FixedPricingByCompanyLocation>;

export const NewFixedPricingByCompany = (data: any): FixedPricingByCompany => {
  if (!data || typeof data !== 'object') return {};
  const result: FixedPricingByCompany = {};
  for (const [locationId, locationData] of Object.entries(data)) {
    const loc = locationData as any;
    const products: Record<string, FixedPricingByCompanyProduct> = {};
    if (loc?.products && typeof loc.products === 'object') {
      for (const [productId, productData] of Object.entries(loc.products)) {
        const p = productData as any;
        products[productId] = {
          amount: p?.amount ?? '0',
          fixedPricingId: p?.fixedPricingId ?? '',
          fixedPricingName: p?.fixedPricingName ?? '',
        };
      }
    }
    const importedProducts: Record<string, ImportedPricingByCompanyProduct> = {};
    if (loc?.importedProducts && typeof loc.importedProducts === 'object') {
      for (const [productId, productData] of Object.entries(loc.importedProducts)) {
        const p = productData as any;
        importedProducts[productId] = {
          amount: p?.amount ?? '0',
          importedPricingId: p?.importedPricingId ?? '',
          importedPricingName: p?.importedPricingName ?? '',
        };
      }
    }
    let adjustment: FixedPricingAdjustment | undefined;
    if (loc?.adjustment) {
      const a = loc.adjustment;
      adjustment = {
        id: a.id ?? '',
        name: a.name ?? '',
        value: a.value ?? '0',
        type: a.type,
      };
    }
    result[locationId] = { products, importedProducts, adjustment };
  }
  return result;
};
